import { PureComponent, PropsWithChildren } from "react";

export default class DescriptionPaneEntry extends PureComponent<PropsWithChildren> {
  render() {
    return (
      <div className="ct-description-pane__entry">{this.props.children}</div>
    );
  }
}
